module.exports = __webpack_public_path__ + "img/LMS-Courses-4.acecf6ee.svg";